import {Base64} from 'js-base64'
import listenEvent from './events';

/**
 * 模板参数base64解析
 * 首先删除目标数据的第11个字符和倒数第11个字符，然后解码
 * @type {string}
 * @return {config}
 */
function decodeTemplate(data) {
	const newData = data.substring(0, 10) + data.substring(11, data.length - 11) + data.substring(data.length - 10)
	return JSON.parse(Base64.decode(newData))
}

/**
 * 判断字符串是不是’true‘
 * @param params
 * @return {*|boolean}
 */
function stringBoolean(params) {
	return params && params === 'true'
}

/**
 * 排序
 * @param list
 * @param key
 * @return {*}
 */
function babelSortObject(list, key, type = 'asc') { // 商品排序
	list.sort(function (a, b) {
		if (type === 'desc') { // 降序
			return parseFloat(b[key]) > parseFloat(a[key]) ? 1 : -1
		} else { // 升序
			return parseFloat(b[key]) < parseFloat(a[key]) ? 1 : -1
		}
	})
	return list
}

function formatPhone(str) { // 格式化手机号码344
	return str.replace(/\B(?=(?:\d{4})+$)/g, ' ')
}

function cancelBlockPlace(str) { // 充值手机号码空格
	return str.replace(/\s+/g, '')
}

function setStorageCache(key, value, jsonString = false) {
	if (jsonString) {
		window.localStorage.setItem(key, JSON.stringify(value))
	} else {
		window.localStorage.setItem(key, value)
	}
}

function getStorageCache(key) {
	try {
		return window.localStorage.getItem(key) || null
	} catch (e) {
		console.warn(`解析失败，原因为：${e}`)
	}
}

function setSessionCache(key, value, jsonString = false) {
	if (jsonString) {
		window.sessionStorage.setItem(key, JSON.stringify(value))
	} else {
		window.sessionStorage.setItem(key, value)
	}
}

function getSessionCache(key) {
	try {
		return window.sessionStorage.getItem(key) || null
	} catch (e) {
		console.warn(`解析失败，原因为：${e}`)
	}
}

/**
 * 格式化金额
 * @param price
 * @return {string}
 */
function formatPrice(price) {
	if (parseFloat(price) > 0) {
		return parseFloat(price).toFixed(2)
	} else {
		return '0'
	}
}

// 获取下单时间戳
function timeString() {
	var now = new Date()
	return now.getUTCFullYear() + [now.getMonth() + 1, now.getDate(), now.getHours(), now.getMinutes(), now.getSeconds()].map(function (item) {
		return item < 10 ? '0' + item : item
	}).join('')
}

function setUrlParams(urlParams, addObj) {
	let searchParams = new URLSearchParams(urlParams)
	for (let key of Object.keys(addObj)) {
		let value = addObj[key]
		searchParams.set(key, value);
	}
	return searchParams.toString()
}

function getUrlParams(urlParams, name) {
	let searchParams = new URLSearchParams(urlParams)
	return searchParams.get(name)
}

function showLogin() {
	listenEvent.emit('toggleLogin', 'show')
}

function hideLogin() {
	listenEvent.emit('toggleLogin', 'hide')
}

function setTitle(text) {
	listenEvent.emit('setTitle', text)
}

function toggleLoading(boolean) {
	if (boolean) {
		listenEvent.emit('showLoading')
	} else {
		listenEvent.emit('hideLoading')
	}
}

function successLogin() {
	listenEvent.emit('toggleLogin', 'hide', 'loginSuccess')
}

function isInWeChat() { // 判断微信环境
	return /micromessenger/.test(navigator.userAgent.toLowerCase())
}

function isInBocApp() { // 中行环境
	return /bocapp/.test(window.navigator.userAgent)
}

function getPayUrl() { // 获取成功失败的url
	let payReturnUrl = ''
	let unpayReturnUrl = ''
	if (1) {
		payReturnUrl = window.location.origin + window.location.pathname + '#/reward'
		unpayReturnUrl = window.location.origin + window.location.pathname + '#/index'
	}
	return {
		payReturnUrl,
		unpayReturnUrl
	}
}

/**
 * 判断当前环境是否是ios
 * @return {boolean}
 */
function isIOS() {
	return /i(phone|pad|os)/.test(navigator.userAgent.toLowerCase());
}

/**
 * 判断当前环境是否是安卓
 * @return {boolean}
 */
function isAndroid() {
	return /android|adr/.test(navigator.userAgent.toLowerCase());
}


function inputFocusScroll() {
	if (isIOS()) {
		setTimeout(() => {
			const scrollHeight = document.documentElement.scrollTop || document.body.scrollTop || 0
			window.scrollTo(0, Math.max(scrollHeight - 1, 0))
		}, 200)
	}
}

// 获取时间戳
function getTimeString(str) {
	if (str) {
		return new Date(str).getTime()
	} else {
		return new Date().getTime()
	}
}

// 展示首页订单
function showOrderList() {
	listenEvent.emit('showOrderList')
}

// 比较版本号
function compareVersion(version1, version2) {
	var v1 = version1.split('.');
	var v2 = version2.split('.');
	for (var i = 0; i < v1.length; i++) {
		if (v1[i] * 1 > v2[i] * 1) {
			return 1;  // 当前版本号大于要求最低版本号
		} else if (v1[i] * 1 < v2[i] * 1) {
			return -1; // 当前版本号小于要求最低版本号
		}
	}
	return 0; // 当前版本号等于要求最低版本号
}

/**
 * 获取随机数
 * @param min
 * @param max
 * @returns {number}
 */
function getRandom(min, max) {
	return Math.floor(Math.random() * (max - min + 1) + min);
}

function getMessageKey(len = 32) {
	let str = ''
	for (let i = 0; i < len; i++) {
		str += getRandom(0, 9)
	}
	return str
}

function updateObject(oldObject, newValues) {
	// 用空对象作为第一个参数传递给 Object.assign，以确保是复制数据，而不是去改变原来的数据
	return Object.assign({}, oldObject, newValues);
}

export {
	decodeTemplate,
	stringBoolean,
	babelSortObject, // 排序
	formatPhone,
	cancelBlockPlace,
	setSessionCache,
	getSessionCache,
	setStorageCache,
	getStorageCache,
	formatPrice,
	timeString,
	setUrlParams,
	getUrlParams,
	showLogin,
	hideLogin,
	setTitle,
	toggleLoading,
	successLogin,
	isInWeChat,
	isInBocApp,
	isIOS,
	isAndroid,
	getPayUrl,
	inputFocusScroll,
	getTimeString,
	showOrderList,
  compareVersion,
	getRandom,
	getMessageKey,
	updateObject,
}
